
import { createContext } from 'react';
import { FutureReleasesContextType } from './types';

export const FutureReleasesContext = createContext<FutureReleasesContextType | undefined>(undefined);
